/**
 * This file contains all model used by the shift RPC endpoint
 *
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    app.model.EventFieldTypeSelectOption = function EventFieldTypeSelectOption(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.value      = obj.value ? obj.value : null;
    };

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.EventFieldTypeOptions = function EventFieldTypeOptions(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.selectOptions = _.map(obj.selectOptions || [], function(o) {
            return new app.model.EventFieldTypeSelectOption(o);
        });
    };

}(window.app));
